module.exports = __webpack_public_path__ + "img/arrow-narrow-up-right.d03f181f.svg";